<template>
  <a-row :gutter="10">
    <a-col  :span="24"  >
        <a-card :bordered="false">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                    <a-form-item label="巡查人">
                        <a-input placeholder="" v-model="queryParam.checkerName"></a-input>
                    </a-form-item>
                </a-col>
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                  <a-form-item label="基地">
                    <j-dict-select-tag  ref="baseSelectRef" placeholder="请选择基地" @chooseFirst="handleBaseChoosedFirst"  v-model="queryParam.baseId" :isChooseFirst="true" dictCode="bus_inspection_general_base,base,id,status=1"  >
                    </j-dict-select-tag>
                  </a-form-item>
                </a-col> 
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                    <a-form-item label="部门">
                      <j-dict-select-tag placeholder="请选择部门"  v-model="queryParam.departId"  :dictCode="departIdDict"  >
                      </j-dict-select-tag>
                    </a-form-item>
                </a-col>
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                    <a-form-item label="区域">
                      <j-dict-select-tag placeholder="请选择区域"  v-model="queryParam.workshopId"  :dictCode="workshopIdDict"  ></j-dict-select-tag>
                    </a-form-item>
                </a-col>
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                    <a-form-item label="改善状态">
                    <j-dict-select-tag  v-model="queryParam.improveStatusPC" placeholder="请选择改善状态"   dictCode="improve_status_pc"/>
                    </a-form-item>
                </a-col>
                <template v-if="toggleSearchStatus">
                    <a-col :xl="5" :lg="7" :md="8" :sm="24">
                      <a-form-item label="责任人">
                          <a-input placeholder="" v-model="queryParam.workerName"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="5" :lg="7" :md="8" :sm="24">
                      <a-form-item label="巡查类型">
                          <a-select  placeholder="请选择巡查类型" v-model="queryParam.inspectionType" >
                            <a-select-option  value=""  key="all" >全部</a-select-option>
                            <a-select-option  value="inspection"  key="inspection" >常规巡查</a-select-option>
                            <a-select-option  value="safety"  key="safety" >安全巡查</a-select-option>
                          </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="10" :lg="11" :md="12" :sm="24"  style="max-width:580px"  >
                    <a-form-item label="时间">
                        <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.startDate"></j-date>
                        <span class="query-group-split-cust"></span>
                        <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.endDate"></j-date>
                    </a-form-item>
                    </a-col>
                </template>
                <a-col :xl="4" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="initDataSource2();searchQuery()" icon="search">查询</a-button>
                    <a-button type="primary" @click="initDataSource2();searchReset()" icon="reload" style="margin-left: 8px">重置</a-button>
                    <a @click="handleToggleSearch" style="margin-left: 8px">
                        {{ toggleSearchStatus ? '收起' : '展开' }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                    </a>
                    </span>
                </a-col>
                </a-row>
            </a-form>
            </div>
            <div class="table-operator">
              <a-button type="primary" icon="download" @click="handleExportXls('异常改善记录表')"  :loading="isExportXlsLoading"  >导出</a-button>
            </div>
            <div>
            <a-table
                ref="table1"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :loading="loading"
                :customRow="customRowTable1"
                :rowSelection="{selectedRowKeys: selectedRowKeys1, onChange: onSelectChange1, type:'radio'}"        
                @change="handleTableChange">
                <template slot="htmlSlot" slot-scope="text">
                    <div v-html="text"></div>
                </template>
                <template slot="imgSlot" slot-scope="text, record,index">
                  <a  @click="onShowPicture(text,record,index);" >查看图片</a>
                </template>
            </a-table>
            </div>
        </a-card>
    </a-col>
    <a-col v-if="rightcolval" :span="24"  >
        <a-card :bordered="false">
            <a-table
                ref="table2"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns2"
                :dataSource="dataSource2"
                :loading="loading">
                <template slot="htmlSlot" slot-scope="text">
                    <div v-html="text"></div>
                </template>
                <template slot="imgSlot" slot-scope="text, record,index">
                  <a  @click="onShowPicture2(text,record,index);" >查看图片</a>
                </template>
            </a-table>
        </a-card>
    </a-col>
    <div class="images" v-viewer="{movable: false}"    >
      <img v-show="false" v-for='item in imageListData' :src="item" :key="item">
    </div>
  </a-row>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { postAction } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate.vue'
  import moment from 'moment'


  export default {
    name: "TableInspectionSummary",
    mixins:[JeecgListMixin],
    components: {
         JDate
    },
    data () {
      return {
        selectedRowKeys1:[],
        selectionRows1:[],
        rightcolval:0,
        currentRoleId:"",
        imageListData:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'巡查人',
            align:"center",
            dataIndex: 'checkUserName',
            width:"120px",
            customRender(text){
              if(text&&(typeof text =="string")){
                return text.split("(")[0]
              }
              return text
            }
          },
          {
            title:'责任科室',
            align:"center",
            dataIndex: 'inspectionWorkshop',
            width:"120px"
          },
          {
            title:'责任人',
            align:"center",
            dataIndex: 'workerUserName',
            width:"120px",
            customRender(text){
              if(text&&(typeof text =="string")){
                return text.split("(")[0]
              }
              return text
            }
          },
          {
            title:'异常详情',
            align:"center",
            dataIndex: 'remarks'
          },
          {
            title:'巡查类型',
            align:"center",
            dataIndex: 'inspectionType',
            customRender(text){
              if(text=="inspection"){
                  return "常规巡查"
              }else if(text="safety"){
                  return "安全任务"
              }
            },
            width:"120px"
          },
          {
            title:'图片',
            align:"center",
            scopedSlots:{
              customRender:"imgSlot"
            },
            width:"120px"
          },
          {
            title:'改善状态',
            align:"center",
            dataIndex: 'improveStatus',
            width:"120px"
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            width:"160px"
          },
          {
            title:'改善完成时间',
            align:"center",
            dataIndex: 'confirmedTime',
            width:"160px"
          },
        ],
        dataSource2:[],
        columns2: [
          {
            title:'类型',
            align:"center",
            dataIndex: 'typeText',
            width:"120px",
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status',
            width:"120px",
          },
          {
            title:'操作人',
            align:"center",
            dataIndex: 'userName',
            width:"120px",
            customRender(text){
              if(text&&(typeof text =="string")){
                return text.split("(")[0]
              }
              return text
            }
          },
          {
            title:'图片',
            align:"center",
            scopedSlots:{
              customRender:"imgSlot"
            },
            width:"120px",
          },
          {
            title:'时间',
            align:"center",
            dataIndex: 'createTime',
            width:"180px",
          },
          {
            title:'原因',
            align:"center",
            dataIndex: 'reason'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remarks'
          },
        ],
        url: {
          list: "/general/busInspectionImprove/list",
          list2: "/general/inspection/api/improve/improveDetailAndApprovalHistory",
          exportXlsUrl:"/general/busInspectionImprove/exportXls"
        },
        customRowTable1:(record)=>{
          return {
            on: { // 事件
              click: (event) => {
                this.onSelectChange1([record.id],[record])
              },       // 点击行
            },
          };
        },
        disableMixinCreated:true,
        departIdDict:"bus_inspection_general_base_depart,depart,id,status='1'",
        workshopIdDict:"bus_inspection_general_depart_workshop,workshop,id,status='1'",
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created(){
      this.toggleSearchStatus=true;
      this.$set(this.queryParam,"startDate",moment().subtract(7, 'days').format("YYYY-MM-DD"));
      this.$set(this.queryParam,"endDate",moment().format("YYYY-MM-DD"))
    },
    methods: {
      async onShowPicture(text,record,index){
        let params={
          orderId:record.taskDetailId,
          fileType:"image",
        }
        let pictureData=await  postAction("/general/inspection/api/file/findFileList",params)
        if(pictureData.result.length==0){
          this.$message.success("暂无图片")
          return
        }
        this.imageListData=[]
        pictureData.result.forEach(item=>{
          this.imageListData.push(item.fileUrl)
        })
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()  
      },
      async onShowPicture2(text,record,index){
        let params={
          orderId:record.id,
          fileType:"image",
        }
        let pictureData=await  postAction("/general/inspection/api/file/findFileList",params)
        if(pictureData.result.length==0){
          this.$message.success("暂无图片")
          return
        }
        this.imageListData=[]
        pictureData.result.forEach(item=>{
          this.imageListData.push(item.fileUrl)
        })
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()  
      },
      initDataSource2(){
        this.dataSource2=[];
        this.selectedRowKeys1 = [];
        this.selectionRows1 = [];
      },
      initDictConfig(){
      },
      loadData2(arg) {
        if (!this.url.list2) {
          this.$message.error('请设置url.list2属性!')
          return
        }
        if (this.currentRoleId === '') return
        let params = {};
        params.id = this.currentRoleId
        this.loading2 = true
        this.dataSource2=[]
        postAction(this.url.list2, params).then((res) => {
          if (res.success) {
            res.result.detailList.forEach(element => {
                if(res.result.improve.hasFives=="1"){
                  if(element.improveApprovalList  &&  element.improveApprovalList.length>0){
                    for (let i = 0; i < element.improveApprovalList.length; i++) {
                      let typeTextStr="";
                      if(element.improveApprovalList.length>=2&&i==0){
                        typeTextStr="巡查人审批"
                      }else{
                        typeTextStr="区域负责人审批"
                      }
                      this.dataSource2.push({
                        typeText:typeTextStr,
                        status:element.improveApprovalList[i].status=="1"?"驳回":"通过",
                        reason:"",
                        remarks:element.improveApprovalList[i].remarks,
                        userName:this.selectionRows1[0].checkUserName,
                        createTime:element.improveApprovalList[i].createTime,
                        id:element.improveApprovalList[i].id
                      })
                    }
                  }
                  this.dataSource2.push({
                      typeText:"5S改善",
                      status:"提交改善方案",
                      reason:element.reason,
                      remarks:element.dealRemarks,
                      userName:this.selectionRows1[0].workerUserName,
                      createTime:element.createTime,
                        id:element.id
                  })
                }else{
                  if(element.improveApprovalList){
                    this.dataSource2.push({
                        typeText:"审批",
                        status:element.improveApprovalList[0].status=="1"?"驳回":"通过",
                        reason:"",
                        remarks:element.improveApprovalList[0].remarks,
                        userName:this.selectionRows1[0].checkUserName,
                        createTime:element.improveApprovalList[0].createTime,
                        id:element.improveApprovalList[0].id
                    })
                  }
                  this.dataSource2.push({
                      typeText:"改善",
                      status:"提交改善方案",
                      reason:element.reason,
                      remarks:element.dealRemarks,
                      userName:this.selectionRows1[0].workerUserName,
                      createTime:element.createTime,
                        id:element.id
                  })
                }
            }); 
          }
          this.loading2 = false
        }).catch(err=>{
          console.log(err)
          if(err.message){
            this.$message.error(err.message);
          }
        })

      },
      onSelectChange1(selectedRowKeys, selectionRows) {
        this.rightcolval = 1
        this.selectedRowKeys1 = selectedRowKeys
        this.selectionRows1 = selectionRows
        this.currentRoleId = selectedRowKeys[0]
        this.loadData2()
      },
      handleBaseChoosedFirst(){
        this.$nextTick(()=>{
          this.loadData(1);
        })
      },
      searchReset () {
        let firsterData=this.$refs.baseSelectRef.getCurrentDictOptions()[0]
        this.queryParam = {
          baseId:firsterData?firsterData.value:undefined,
        }
        this.loadData(1);
      },
    },
    watch:{
      "queryParam.baseId":{
        deep:true,
        handler(newValue){
          console.log("newValue")
          console.log(newValue)
          if(newValue){
            this.departIdDict=`bus_inspection_general_base_depart,depart,id,status='1' AND base_id='${newValue}'`
            return
          }
          this.departIdDict="bus_inspection_general_base_depart,depart,id,status='1'"
        }
      },
      "queryParam.departId":{
        deep:true,
        handler(newValue){
          console.log("newValue")
          console.log(newValue)
          if(newValue){
            this.workshopIdDict=`bus_inspection_general_depart_workshop,workshop,id,status='1' AND depart_id='${newValue}'`
            return
          }
          this.workshopIdDict="bus_inspection_general_depart_workshop,workshop,id,status='1'"
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>